import { render, staticRenderFns } from "./MinusSimpleIcon.vue?vue&type=template&id=73627204&"
import script from "./MinusSimpleIcon.vue?vue&type=script&lang=js&"
export * from "./MinusSimpleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports